// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"uJ-z","loadingMedia":"vJ-z","reviewsImagesAndVideos":"wJ-z","limitHeight":"xJ-z"};